export function reversed(value) {
    // slice to make a copy of array, then reverse the copy
    return value.slice().reverse();
  }